import React, { createContext, useContext, useMemo } from 'react';
import { getColorVariants } from '../utils/colors';

const ThemeContext = createContext(null);

export function ThemeProvider({ children, merchantData }) {
  const color1 = merchantData?.config?.color1 || '#2563eb'; // Default blue-600
  const color2 = merchantData?.config?.color2 || '#10b981'; // Default green-500

  const theme = useMemo(() => ({
    colors: {
      primary: getColorVariants(color1),
      secondary: getColorVariants(color2),
      rawPrimary: color1,
      rawSecondary: color2
    }
  }), [color1, color2]);

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
